/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentType/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AppointmentType({
  children,
  viewPath = "/DesignSystem/EditAutomation/AppointmentType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let automationEventTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'event_type',
})
let constantData = 'appointment_bookings_state_update'
let aggregateData = fromAggregate.equals(automationEventTypeValueData, constantData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}